const CustomerCartVoucherService = {
  isDiscounted: (discount) => {
    const isShipmentDiscounted = discount.discount_shipment > 0
    const isItemsDiscounted    = discount.discount_items.length > 0
    return (isShipmentDiscounted || isItemsDiscounted)
  }
}

export default CustomerCartVoucherService